import { render, staticRenderFns } from "./menu-intro.vue?vue&type=template&id=4c761374&"
import script from "./menu-intro.vue?vue&type=script&lang=js&"
export * from "./menu-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports